module.exports = __webpack_public_path__ + "img/1_017.2ca73317.jpg";